import React from 'react';

/**
 * StatusBadge — small pill with the KR brand palette.
 *
 * Variants:
 *   neutral | brand | success | warning | danger | info
 */
export const StatusBadge = ({ variant = 'neutral', icon: Icon, children, className = '', testId }) => (
  <span className={`kr-badge kr-badge-${variant} ${className}`} data-testid={testId}>
    {Icon && <Icon size={12} />}
    {children}
  </span>
);

export default StatusBadge;
